import { useRequest } from 'ahooks'
import { ApiInstance } from '@/api'

const getDepositAddressByBtc = async () => {
  const resp = await ApiInstance.post<{ address: string }>('', { cmd: 'apid.get_unify_deposit_addr' })
  return resp.para.address
}

const useDepositAddressByBtc = () => {
  return useRequest(getDepositAddressByBtc, {
    cacheKey: 'DepositAddressByBtc',
  })
}

export default useDepositAddressByBtc
